<template>
  <div class="legal-view view">
    <div class="legal-content-view content-view">
      <div class="lv-header">LEGAL</div>

      <div class="lv-rules-container" ref="lvRulesContainer">
        <div class="lv-rules">
          <p>
            *No Purchase Necessary. Open April 29, 2020 and closes at 11:59:59
            PM ET on June 23, 2020. Must be a legal resident of Canada
            (excluding Quebec) who have reached age 13 in their jurisdiction of
            residence. Select winners that manage to collect all 6 Jolly
            Ranchers Misfits characters, will be randomly selected by a draw at
            the end of the campaign period, and notified if they are deemed a
            winner of exclusive Jolly Rancher prizes. One of three prizes
            available: Jolly Rancher Prize pack including exclusive merch and
            Jolly Rancher Misfits Gummies (approx. value of $300 each). Odds of
            winning depend on the number of eligible entries received before
            June 14, 2020 and skill in meeting criteria. Math skill test and
            internet access required. Users will need to provide their personal
            information including full name, address, and contact info in order
            to qualify.
          </p>
        </div>
      </div>

      <div class="lv-close-btn" @click="handleCloseBtnClicked"></div>
    </div>
  </div>
</template>

<script>
import store from "@/store/index.js";
export default {
  methods: {
    handleCloseBtnClicked() {
      store.dispatch("general/setLegalVisible", false, { root: true });
    },
  },
};
</script>

<style lang="scss" scoped>
$padding-top: 100px;
$mobile-padding-top: 23vh;

.legal-view {
  position: absolute;
  top: 0px;
  width: 100%;
  padding-top: #{$padding-top};
  overflow-y: hidden;
  z-index: 100;
  user-select: auto;
  background-color: white;
}

.legal-content-view {
  position: relative;
  font-size: 2rem;
  // height: calc(var(--vh, 1vh) * 100 - 34vh - 1.1em);
  height: calc(var(--vh, 1vh) * 100 - #{$padding-top});
  // height: calc(var(--vh, 1vh) * 100);
  // overflow-y: auto;
  // width: 90%;
  // margin: 1em auto 0 auto;
  text-align: left;
}

.lv-header {
  //   @include font-knewave;
  color: $font-dark-blue-color;
  font-size: 2rem;
  height: 1.1em;
  text-align: center;
}

.lv-rules-container {
  position: absolute;
  height: calc(var(--vh, 1vh) * 100 - 34vh - 1.1em);
  // height: calc(var(--vh, 1vh) * 100 - 20vh - 1.1em);
  // height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 80%;
  left: 10%;
  margin: 1em auto 0 auto;
  text-align: left;
  background-color: rgba(0, 0, 0, 0);
}

.lv-rules {
  position: absolute;
  font-size: 0.8em;
  // pointer-events: none;
  // user-select: none;

  &::v-deep p {
    margin-top: 0;
    margin-bottom: 0;
  }

  ol {
    font-size: 0.8em;
    padding-left: 2em;
    margin-top: 1em;
  }

  li {
    text-align: left;
    margin-bottom: 1em;
  }
}

.lv-close-btn {
  position: absolute;
  width: 2rem;
  height: 2rem;
  right: 10%;
  top: -5%;
  background-image: url("~@/assets/images/close_btn.png");
  background-size: contain;
  background-repeat: no-repeat;
}

@include mobile {
  .legal-view {
    padding-top: #{$mobile-padding-top};
  }

  .legal-content-view {
    height: calc(var(--vh, 1vh) * 100 - #{$mobile-padding-top});
  }
}

@include mobile-small {
}
</style>
